import {ComponentType} from '@angular/cdk/overlay';
import {Injectable} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {DialogComponent, DialogData} from '../components/dialog/dialog.component';

@Injectable({
    providedIn: 'root',
})
export class DialogService {
    private defaultConfig = {
        width: '500px',
        panelClass: ['ui-kit-dialog'],
    };

    private fitContentWidthConfig = {
        panelClass: ['ui-kit-dialog-w-fit-content'],
    };

    constructor(private matDialogService: MatDialog) {
    }

    openDialog(data: DialogData, customizeConfig: Record<string, any> = null): Observable<boolean> {
        return this.openConfiguredDialog({...this.defaultConfig, ...customizeConfig, data}, DialogComponent);
    }

    openDialogFitContent(data: DialogData, customizeConfig: Record<string, any> = null): Observable<boolean> {
        return this.openConfiguredDialog({...this.fitContentWidthConfig, ...customizeConfig, data}, DialogComponent);
    }

    openCustomDialog<D, T>(
        dialogReference: ComponentType<D>,
        data?: Record<string, any>,
        customizeConfig: Record<string, any> = null,
    ): Observable<T> {
        return this.openConfiguredDialog(
            {
                ...this.defaultConfig,
                ...customizeConfig,
                data,
            },
            dialogReference,
        );
    }

    showCustomDialog<D, T>(
        dialogReference: ComponentType<D>,
        data?: Record<string, any>,
        customizeConfig: Record<string, any> = null,
    ): MatDialogRef<D, T> {
        return this.showConfiguredDialog(
            {
                ...this.defaultConfig,
                ...customizeConfig,
                data,
            },
            dialogReference,
        );
    }

    openCustomDialogFitContent<D, T>(
        dialogReference: ComponentType<D>,
        data?: Record<string, any>,
        customizeConfig: Record<string, any> = null,
    ): Observable<T> {
        return this.openConfiguredDialog(
            {
                ...this.fitContentWidthConfig,
                ...customizeConfig,
                data
            },
            dialogReference
        );
    }

    closeAllDialogs(): void {
        this.matDialogService.closeAll();
    }

    private openConfiguredDialog<D, T>(config: Record<string, any>, dialogReference: ComponentType<D>): Observable<T> {
        return this.showConfiguredDialog(config, dialogReference).afterClosed();
    }

    private showConfiguredDialog<D>(config: Record<string, any>, dialogReference: ComponentType<D>): MatDialogRef<D, any> {
        return this.matDialogService.open(dialogReference, config);
    }
}
